import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class AuthenticatedRoutesGuard  {

    constructor(
        private authService: AuthService
    ) { }

    canActivate(): boolean | Promise<boolean> {
        return this.authService.getUserDataFromSession().then(userData => {
            return this.authService.checkGigyaAndServerSession().then(() => {
                if (userData) {
                    return true;
                } else {
                    this.authService.rurl = window.location.pathname + window.location.search;
                    return false;
                }
            });
        });
    }
}